import { render } from "./AddModeleNotificationModal.vue?vue&type=template&id=d182213e&ts=true"
import script from "./AddModeleNotificationModal.vue?vue&type=script&lang=ts"
export * from "./AddModeleNotificationModal.vue?vue&type=script&lang=ts"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__